import * as React from "react";
import { Box, Typography, Button, styled } from "@mui/material";
import { ReactNode } from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InboxIcon from "@mui/icons-material/Inbox";
import SearchOffIcon from "@mui/icons-material/SearchOff";

interface EmptyStateProps {
  type: "noData" | "error" | "noResults";
  message?: string;
  icon?: ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const StyledEmptyState = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  minHeight: "200px",
  padding: theme.spacing(4),
  textAlign: "center",
}));

const EmptyState: React.FC<EmptyStateProps> = ({
  type,
  message,
  icon,
  action,
}) => {
  const defaultMessages = {
    noData: "No data available",
    noResults: "No results found",
    error: "Something went wrong",
  };

  const defaultIcons = {
    noData: <InboxIcon sx={{ fontSize: 64, color: "text.secondary" }} />,
    noResults: (
      <SearchOffIcon sx={{ fontSize: 64, color: "text.secondary" }} />
    ),
    error: <ErrorOutlineIcon sx={{ fontSize: 64, color: "error.main" }} />,
  };

  const displayMessage = message || defaultMessages[type];
  const displayIcon = icon || defaultIcons[type];

  return (
    <StyledEmptyState>
      <Box sx={{ mb: 2 }}>{displayIcon}</Box>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {displayMessage}
      </Typography>
      {action && (
        <Button
          variant="contained"
          onClick={action.onClick}
          sx={{ mt: 2 }}
        >
          {action.label}
        </Button>
      )}
    </StyledEmptyState>
  );
};

export default EmptyState;
